// import React from 'react';
// import { TextField } from '@material-ui/core';

// const InputComponent = ({ inputRef, ...other }) => <div {...other} />;
// const OutlinedDiv = ({ children, label }) => {
//   return (
//     <TextField
//       fullWidth
//       margin="dense"
//       variant="outlined"
//       label={label}
//       multiline
//       InputLabelProps={{ shrink: true }}
//       InputProps={{
//         inputComponent: InputComponent,
//       }}
//       inputProps={{ children: children }}
//     />
//   );
// };
// export default OutlinedDiv;

import React from 'react';
import ReactDOM from 'react-dom';
import InputLabel from '@material-ui/core/InputLabel';
import NotchedOutline from '@material-ui/core/OutlinedInput/NotchedOutline';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  root: {
    position: 'relative',
  },
  content: {
    padding: '10px 5px 5px 5px',
    borderRadius: 4,
  },
  denseContent: {
    paddingTop: 3,
    borderRadius: 4,
  },
  inputLabel: {
    position: 'absolute',
    left: 0,
    top: 0,
    // slight alteration to spec spacing to match visual spec result
    transform: 'translate(0, 24px) scale(1)',
  },
};

const LabelledOutline = ({ classes, id, label, children, dense }) => {
  const [labelWidth, setLabelWidth] = React.useState(0);
  const labelRef = React.useRef(null);
  React.useEffect(() => {
    const labelNode = ReactDOM.findDOMNode(labelRef.current);
    setLabelWidth(labelNode != null ? labelNode.offsetWidth : 0);
  }, [label]);

  return (
    <div style={{ position: 'relative', marginTop: '8px' }}>
      <InputLabel ref={labelRef} htmlFor={id} variant="outlined" className={classes.inputLabel} shrink>
        {label}
      </InputLabel>
      <div className={classes.root}>
        <div id={id} className={dense ? classes.denseContent : classes.content}>
          {children}
          <NotchedOutline notched labelWidth={labelWidth} />
        </div>
      </div>
    </div>
  );
};
export default withStyles(styles)(LabelledOutline);
